<template>
  <component :is="dashboardComponent" />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useChallengeStore } from '../../stores/challenge';
import { ChallengeTypeEnum } from '../../types/challenge';
import DefaultChallengeDashboard from './DefaultChallengeDashboard.vue';
import ContentBaseChallengeDashboard from './ContentBaseChallengeDashboard.vue';

const challengeStore = useChallengeStore();
const { challenge } = storeToRefs(challengeStore);
const challengeTypeToDashboard = {
  [ChallengeTypeEnum.Values.contentBased]: ContentBaseChallengeDashboard,
  valueBased: DefaultChallengeDashboard,
  dailyTaskBased: DefaultChallengeDashboard,
  percentBased: DefaultChallengeDashboard,
  personalValueBased: DefaultChallengeDashboard,
};

const dashboardComponent = challengeTypeToDashboard[challenge.value.type];
</script>

<style lang="scss" scoped>
</style>
